import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import toast from "react-hot-toast";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(false);

  // Mutation for forgot password
  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => postRequest(`/user/forgotPassword`, data), // 🔹 Change API endpoint
    onMutate: () => setLocalLoading(true),
    onSuccess: (data) => {
      toast.success(`${data?.message || "Password reset link sent!"}`, {
        iconTheme: {
          primary: "#337FE0",
          secondary: "#FFFAEE",
        },
      });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
      console.error("Error during API call:", error);
    },
    onSettled: () => setLocalLoading(false),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    validateOnBlur: false,
    onSubmit: () => {}, // prevent default handling
  });

  // Manual submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // mark field as touched
    formik.setTouched({ email: true });

    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      mutate({ email: formik.values.email ,  role:"user"}); // 🔹 Only send email
    }
  };

  return (
    <section className="commn-bg-set">
      <div className="card-center-set">
        <div className="commn-card-theme">
          <img
            className="side-logo-set"
            src={require("../Assets/images/logo-main.png")}
            alt="Logo"
          />
          <h2>Forgot Password</h2>
          <p>Enter your email to reset your password</p>

          <div className="register-data">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="eg: sarah@example.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                {formik.touched.email && formik.errors.email && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "14px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.email}
                  </div>
                )}
              </Form.Group>

       
              <Button
                variant="primary"
                type="submit"
                disabled={isLoading || localLoading}
              >
                {localLoading ? "Sending..." : "Send Reset Link"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}
